import { Routes, Route } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { IframeHeader } from "./components/IframeHeader";
import { IframeLayout } from "./layout/Iframe";
import { IframeFooter } from "./components/IframeFooter";
import { AnalyticsBrowser } from "@segment/analytics-next";
export const analytics = AnalyticsBrowser.load({
	writeKey: process.env.REACT_APP_SEGMENT_API_KEY || ""
});

function App() {
	const { t } = useTranslation();

	document.title = t("title");
	return (
		<Routes>
			<Route path="pages">
				<Route path="iframe" element={<IframeLayout />}>
					<Route path="header" element={<IframeHeader />} />
					<Route path="footer" element={<IframeFooter />} />
				</Route>
			</Route>
		</Routes>
	);
}

export default App;
